function roundToOneHundred(l, target) {
  //https://stackoverflow.com/questions/13483430/how-to-make-rounded-percentages-add-up-to-100
  const off = target - l.reduce((acc, value) => acc + Math.round(value), 0);
  return l.map((value, index) => Math.round(value) + (off > index) - (index >= l.length + off));
}

export default roundToOneHundred;
